import { css } from "styled-components";
export default ((props, speed = 0.15, ease = "ease-in-out") => css(["transition:", "s ", ";transition-property:", ";"], speed, ease, props.join(",")));
//# sourceMappingURL=transition.js.map